import React, { useCallback } from 'react';
import LootBoxPopper from '../components/LootBoxPopper';
import { supabase } from '../services/supabase';
import './DailyRewardPage.css';

interface DailyRewardPageProps {
  userData: any;
}

export default function DailyRewardPage({ userData }: DailyRewardPageProps) {
  const handleClaimed = useCallback(async () => {
    if (!userData?.id) return;
    try {
      const { data } = await supabase
        .from('users')
        .select('balls_balance')
        .eq('id', userData.id)
        .single();
      if (data) {
        (window as any).__refreshUserData({ balls_balance: data.balls_balance });
      }
    } catch (err) {
      console.error('Failed to refresh balance after daily reward:', err);
    }
  }, [userData?.id]);

  if (!userData) {
    return (
      <div className="sf-page daily-reward-page">
        <div className="daily-reward-center">
          <div className="daily-reward-signin">
            <div className="daily-reward-signin-icon">🎁</div>
            <h1 className="sf-page-title">Daily Reward</h1>
            <p className="sf-page-subtitle">Sign in to open your daily loot box for a free reward!</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sf-page daily-reward-page">
      <div className="daily-reward-center">
        <div className="daily-reward-header">
          <h1 className="sf-page-title">Daily Reward</h1>
          <p className="sf-page-subtitle">Open your daily loot box for a free reward!</p>
        </div>
        <LootBoxPopper userData={userData} onClaimed={handleClaimed} />
      </div>
    </div>
  );
}
